<template>
  <div
    :class="getAlignmentClasses()"
    class="ListCallToActionBullet"
  >
    <div
      v-if="isLeft()"
      class="ListCallToActionBullet-IconWrapper"
    >
      <div class="ListCallToActionBullet-IconContainer">
        <the-icon
          :icon="icon"
          class="ListCallToActionBullet-Icon"
        />
      </div>
    </div>

    <div
      class="ListCallToActionBullet-DataWrapper"
    >
      <h1
        class="ListCallToActionBullet-TitleWrapper"
        v-html="title"
      />
      <h2
        class="ListCallToActionBullet-DescriptionWrapper"
        v-html="description"
      />
    </div>

    <div
      v-if="isRight()"
      class="ListCallToActionBullet-IconWrapper"
    >
      <div class="ListCallToActionBullet-IconContainer">
        <the-icon
          :icon="icon"
          class="ListCallToActionBullet-Icon"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .ListCallToActionBullet {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    padding-top: 20px;

    &--left {
        text-align: left;
        margin-right: auto;
        padding-left: 20px;
    }

    &--right {
        text-align: right;
        margin-left: auto;
        padding-right: 20px;
    }

    &-IconWrapper {
      flex: 0 0 auto;
      margin: 10px;
      text-align: center;
    }

    &-IconContainer {
      background-color: $color-button-primary-background;
      border-radius: 100px;
      width: 90px;
      height: 90px;
    }

    &-Icon {
      position: relative;
      top: 6px;
      padding: 13px;
      color: $color-button-primary-foreground;
      font-size: 50px;
    }

    &-DataWrapper {
      flex: 1 1 auto;
      margin: 0 20px;
    }

    &-TitleWrapper {
      padding: 10px 0 0 0;
      margin: 0;
      font-size: 26px;
    }

    &-DescriptionWrapper {
      margin: 0;
      padding: 0;
      font-size: 18px;
    }
  }
</style>

<script>
  import ICON_CLASS_MAP from "@/common/icons";
  import TheButton from "@/components/TheButton";
  import TheIcon from "@/components/TheIcon";
  import RoundedButton from './RoundedButton.vue';

  export default {
    name: "ListCallToActionBullet",

    components: {
      TheIcon,
      TheButton,
      RoundedButton,
        TheIcon,
    },

    props: {
      icon: {
        type: String,
        default: "asterisk",
        validator: function(value) {
          return value in ICON_CLASS_MAP;
        },
      },

      side: {
        type: String,
        default: "left",
        validator: function(value) {
          return ["left", "right"].indexOf(value) !== -1;
        },
      },

      title: {
        type: String,
        default: "Título",
      },

      description: {
        type: String,
        default: "Descrição",
      },
    },

    methods: {
      getAlignmentClasses() {
        return ["ListCallToActionBullet--" + this.side];
      },

      isLeft() {
        return this.side == "left";
      },

      isRight() {
        return this.side == "right";
      },

      click() {
        this.$emit("click");
      },
    },
  };
</script>
